import c from 'underscore.string/capitalize';

const capitalize = (string: string) => {
  return c(string);
};

export default capitalize;
